module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe5c540207578aec477625f4a23c9db01.e5c54020.png";